import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
export interface DynamicDetailData {
  id: number;
  key: string;
  value: string;
}
@Component({
  selector: 'app-batch-audit',
  templateUrl: './batch-audit.component.html',
  styleUrls: ['./batch-audit.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class BatchAuditComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('name') inputName;

  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  
  isFilter:boolean=false
  // column header
  public columns = [
    { name: "Batch Name", prop: "name" },
    { name:"Catagory",prop:"catagory"},
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = [];
  imageUrl=environment.apiUrls.imageUrl;

  batch_id:any
  user_role:any

  batch_data:any
  row_name:any
  row_prop:any
  row_value:any
  
  alert_list=[
    {id:'yes', name:'Yes'},
    {id:'no', name:'No'},
  ]
  alert_event:any
  lastAudit:any
  catId='6319d5025ab9e462a96cfbba'
  technology_List=[]
  selectedTechnology:any=null
  dropdownList = [
    { name: 'All', id: '' },
    { name: 'Project', id: '644a5c52af0db342c32eeaf8' },
    { name: 'Product', id: '644a5c84af0db342c32eeb02' },
  ];
  workon_id=''
  project_type:any

  guideline_data:any
  row_data:any
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) dynamicContainer: ViewContainerRef;
  pageNumberSubscription : Subscription

  constructor(public apiService:ApiService,
              private modalService: NgbModal,
              private changeDetectorRef: ChangeDetectorRef,
              public toastr: ToastrService,private router : Router,
              private spinner: NgxSpinnerService,private resolver: ComponentFactoryResolver,
              private store: Store<AppState>,private activerouter : ActivatedRoute) {

              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              this.guideline_data = setting_data.filter((item) => item.key == 'Batch Audit') 
              
              this.activerouter.queryParamMap.subscribe((params) => {
                let page = +params.get('page');
                this.setPage(page)
              });
              this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
              .subscribe(pageNumber => {
                this.page.pageNumber = pageNumber;
                if(pageNumber !==undefined){
                  this.page.pageNumber = pageNumber -1
                }
                if(pageNumber === 0) this.page.pageNumber = 0
                
              });
    
            }

  ngOnInit(): void{
    this.getJobsList()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
 
  getJobsList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      this.apiService.getBatchList(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows=res.data.items
      this.page.totalPages=res.data.totalCount
      
    })
  }
pageChangeData(page:any){
  this.router.navigate([], {
    relativeTo: this.activerouter,
    queryParams: { page: page.offset +1 },
    queryParamsHandling: 'merge' // keep existing query params
  });
  this.spinner.show(undefined,
    {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
  this.apiService.getBatchList(page.offset +1,this.limitRef).subscribe((res:any)=>{
    this.spinner.hide()
    this.setPage(page.offset +1)
    this.rows=res.data.items
    this.page.totalPages=res.data.totalCount

  })
}
getTechnologyList(){
  this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res:any)=>{
    this.technology_List=res.data.slice(0, 4)
    let list={_id:'all',displayname:'All'}
    this.technology_List.push(list)
    this.technology_List.sort((a, b) => {
      if (a.displayname < b.displayname) { return -1; }
      if (a.displayname > b.displayname) { return 1; }
      return 0;
    });
  })
 }
getFilterProject(data){
  let search=data
  if(search){
    this.apiService.getFilterJobs(search).subscribe((res:any)=>{
      this.rows=res.data
    })
  }
  else{
    this.getJobsList()
  }
}
resetFilter() {
  this.inputName.nativeElement.value = null;
  this.getJobsList()
}
  deleteProject(password){
    if(this.batch_id){
      this.apiService.deleteBatch(this.batch_id,password).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getJobsList()
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }
  // ================== Delete Alert ========================
  ConfirmColor(id:any) {
    this.batch_id = id
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteProject(result.value)
  
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
  }
  
  // ==========================================

  openModal(content,data,rowName,prop,rowValue,alertVal,lastAuditVal) {
    this.batch_data=data
    this.row_name=rowName
    this.row_prop=prop
    this.row_value=rowValue
    this.alert_event=alertVal
    this.lastAudit=lastAuditVal
  
    const modalRef = this.modalService.open(content);
   
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  selectAlert(event){
    this.alert_event
  }

  updateRow(){
    let name=''
    name=this.row_prop
    let body={
      [name]: {
        description:this.row_value,
        is_alert : this.alert_event,
        last_aditdate : this.lastAudit
      },
    }
    this.apiService.updateBatch(this.batch_data?._id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.getJobsList()
        this.modalService.dismissAll()
      }
    })
  }
  editJob(row){
    this.router.navigate(['project-edit/:id',row?._id])
  }
  getUserById() {
    this.apiService.getUserbyId(this.user_role.id).subscribe((res: any) => {
      let emp_data=res?.data
      this.selectedTechnology=emp_data?.technology[0]?.displayname
      if(emp_data?.technology.length==0){
        this.selectedTechnology='All'
      }
    })
  }
  getTechnologyId(event_id,event_name){
    this.selectedTechnology=event_name
    if(event_id.displayname !=='All' && this.selectedTechnology){
      let formData=new FormData();
      formData.append('technology',event_id)
      this.apiService.updateUser(this.user_role.id,formData).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getJobsList()
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
      else{
      let formData=new FormData();
        formData.append('technology',event_id._id)
        this.apiService.updateUser(this.user_role.id,formData).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.getJobsList()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
     
   }
   getProjectTypeId(id, name) {
    this.project_type = name
    if(name === 'All'){
      this.workon_id = ''
      this.project_type = name
      this.getJobsList()
    }
    if(name !== 'All'){
      this.workon_id = id
      this.project_type = name
      this.getJobsList()
    }
  }

  createDynamicComponent(data:DynamicDetailData) {
    this.row_data =data
    // Create a factory for the dynamic component
    const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);

    // Create an instance of the dynamic component
    const componentRef = factory.create(this.dynamicContainer.injector);

    // Set the data for the dynamic component
    componentRef.instance.data = data;

    // Insert the dynamic component into the view container
    this.dynamicContainer.insert(componentRef.hostView);
  }

}